const isPhoneValid = phone =>
	/^[+]?[(]?[0-9]{2,3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{2,12}$/im.test(phone);

export default isPhoneValid;
